/**
 * UnauthorizedPage.jsx
 *
 * Shown when the authenticated user does not belong to a group that is
 * allowed to access a particular page.
 *
 * Props:
 *   pageName      {string}  — Human-readable name of the restricted page.
 *   effectiveRole {string}  — Optional derived role to display (for debugging).
 */

import React from 'react';

export default function UnauthorizedPage({ pageName, effectiveRole }) {
  return (
    <div style={styles.container}>
      <div style={styles.icon}>🔒</div>
      <div style={styles.title}>Access Restricted</div>
      <div style={styles.body}>
        {pageName ? (
          <>You don't have permission to access <strong>{pageName}</strong>.</>
        ) : (
          <>You don't have permission to access this section.</>
        )}
      </div>
      {effectiveRole && (
        <div style={styles.roleChip}>
          Your role: <strong>{effectiveRole}</strong>
        </div>
      )}
      <div style={styles.hint}>
        Contact your administrator if you believe this is an error.
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '48px 24px',
    textAlign: 'center',
    gap: 12,
    minHeight: 260,
    fontFamily: "'Helvetica Neue', Arial, sans-serif",
  },
  icon:  { fontSize: 42, lineHeight: 1 },
  title: { fontSize: 16, fontWeight: 700, color: '#1A2E44', margin: 0 },
  body:  { fontSize: 13, color: '#4A5568', maxWidth: 300, lineHeight: 1.6, margin: 0 },
  roleChip: {
    background: '#EEF2F7',
    border: '1px solid #CBD5E0',
    borderRadius: 20,
    padding: '4px 14px',
    fontSize: 12,
    color: '#2D3748',
  },
  hint: { fontSize: 11, color: '#8A96A3', maxWidth: 280, marginTop: 4 },
};
